import { object, optional, runSchema, str } from 'validation';

export type NodeInstanceUpdateResponse = {
  rematerialize_status?: string;
  rematerialize_reason?: string;
};

const nodeInstanceUpdateResponseSchema = object<NodeInstanceUpdateResponse>({
  rematerialize_status: optional(str()),
  rematerialize_reason: optional(str()),
});

export function parseNodeInstanceUpdateResponse(data: unknown, context: string): NodeInstanceUpdateResponse {
  const result = runSchema(nodeInstanceUpdateResponseSchema, data, context);
  if (!result.ok) {
    return {};
  }
  return result.value;
}

/** Returns a user-facing warning when nested flow rematerialize was skipped, else null. */
export function deriveRematerializeWarning(data: unknown): string | null {
  const parsed = parseNodeInstanceUpdateResponse(data, 'PUT /node_instances/:id');
  if (parsed.rematerialize_status !== 'skipped') {
    return null;
  }
  if (parsed.rematerialize_reason) {
    return `Instance schedule/parameters were updated, but nested flow children were not refreshed: ${parsed.rematerialize_reason}`;
  }
  return 'Instance schedule/parameters were updated, but nested flow children were not refreshed.';
}
